import React from 'react';
import StepByStepList from '@components/StepByStepList/StepByStepList';
import type { StepByStepListProps } from '@components/StepByStepList/StepByStepList.types';

interface StepByStepListSerializerProps {
  value: StepByStepListProps;
}

export const StepByStepListBlock = ({ value }: StepByStepListSerializerProps) => (
  <StepByStepList title={value.title} ingress={value.ingress} list={value.list} variant={value.variant} />
);
